<template>
  <div>
    <div class="w-full flex flex-col items-start gap-[16px] sm:gap-[26px]">
      <div class="w-full flex items-center  flex-wrap">
        <div class="flex items-center gap-[8px] mr-[26px]">
          <TableIcon class="!text-primary w-[40px] h-[40px]" />
          <div class="PC_H1-SB text-[#1F1D1F]">แบบประเมินออฟไลน์</div>
        </div>
        <!-- v-if="isOnline == false" -->
        <ButtonComponent v-if="isOnline == false" :icon="'AddIcon'" :label="'ทำประเมินออฟไลน์'"
          :bClass="'mr-[10px] btn_shadow--1 hover:!bg-[#841D69]'" :disabled="offlineList.length >= Number(MAX_ITEMS)" @clicked="addAssessment(2)" />
        <ButtonComponent v-if="isOnline == false" :icon="'AddIcon'" :label="'ทำบันทึกการตรวจเยี่ยมออฟไลน์'"
          :bClass="'btn_shadow--1 hover:!bg-[#841D69]'" :disabled="offlineList.length >= Number(MAX_ITEMS)" @clicked="addAssessment(1)" />
      </div>
      <div class="flex items-center gap-[8px]">
        <InfoIcon class="text-primary w-[20px] h-[20px]" />
        <span class="text-primary-dark">ระบบทำแบบประเมินออฟไลน์ โปรดทำการ Sync ข้อมูลก่อนออกจากระบบทุกครั้ง
          เพื่อป้องกันการสูญหายของข้อมูล</span>
      </div>

      <div class="w-full flex flex-col gap-[20px]">
        <!-- table -->
        <div
          class="w-full p-[6px] flex flex-col bg-[#FFFFFF] rounded-[6px] border-[1px] border-solid border-[#B7B2B5] overflow-auto">
          <table class="min-w-[840px]">
            <thead>
              <tr>
                <th
                  class="py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                  <span class="PC_Body2-R"> ครั้งที่ </span>
                </th>
                <th
                  class="py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                  <span class="PC_Body2-R"> ชื่อแบบประเมิน </span>
                </th>
                <th
                  class="py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                  <span class="PC_Body2-R"> ชื่อผู้ถูกประเมิน </span>
                </th>
                <th
                  class="py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                  <span class="PC_Body2-R"> วันที่ประเมิน </span>
                </th>
                <th
                  class="py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                  <span class="PC_Body2-R"> วันที่ และเวลาที่สร้าง </span>
                </th>
                <th
                  class="py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                  <span class="PC_Body2-R"> สถานะการซิงค์ข้อมูล </span>
                </th>
                <th
                  class="py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- {{ offlineList }} -->
              <tr v-for="row in offlineList" :key="row.id"
                :class="['!border-none', { 'bg-[#FBEFF8]': (rowIndex + 1) % 2 === 0 }]">
                <td class="p-[10px] !border-none">
                  <span class="PC_Body2-R text-[#1F1D1F]">-</span>
                </td>
                <td class="p-[10px] !border-none">
                  <span class="PC_Body2-R text-[#1F1D1F]">
                    {{ typeToName(row.type) }}
                  </span>
                </td>
                <td class="p-[10px] !border-none">
                  <span class="PC_Body2-R text-[#1F1D1F]">
                    {{ row?.data?.data?.name || row?.name }}
                  </span>
                </td>
                <td class="p-[10px] !border-none">
                  <span class="PC_Body2-R text-[#1F1D1F]">
                    <!-- {{ row?.data?.detail?.assessment?.datetime }} -->
                    {{
                      (() => {
                        const [y, m, d] = row?.data?.datetime?.split('-') || [];
                        return y ? `${d}/${m}/${Number(y) + 543}` : '-';
                      })()
                    }}
                  </span>
                </td>
                <td class="p-[10px] !border-none">
                  <span class="PC_Body2-R text-[#1F1D1F]">
                    {{ formatThaiDate(row.created_at) }}
                  </span>
                </td>
                <!-- {{ row.data.create_by }} -->
                <td class="p-[10px] !border-none">
                  <!-- {{ row?.data?.synecedId }} -->
                  <!-- {{ row?.data?.synced }} -->
                  <div class="flex flex-row gap-1 justify-center" v-if="row?.data?.synced || row?.data?.data?.synced">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"
                      class="mt-0.5">
                      <path
                        d="M9.325 10.125L7.925 8.725C7.725 8.525 7.49167 8.425 7.225 8.425C6.95833 8.425 6.725 8.525 6.525 8.725C6.325 8.925 6.225 9.1625 6.225 9.4375C6.225 9.7125 6.325 9.95 6.525 10.15L8.65 12.3C8.85 12.5 9.08333 12.6 9.35 12.6C9.61667 12.6 9.85 12.5 10.05 12.3L14.275 8.075C14.475 7.875 14.575 7.63333 14.575 7.35C14.575 7.06667 14.475 6.825 14.275 6.625C14.075 6.425 13.8333 6.325 13.55 6.325C13.2667 6.325 13.025 6.425 12.825 6.625L9.325 10.125ZM5.5 16C3.98333 16 2.6875 15.475 1.6125 14.425C0.5375 13.375 0 12.0917 0 10.575C0 9.275 0.391667 8.11667 1.175 7.1C1.95833 6.08333 2.98333 5.43333 4.25 5.15C4.66667 3.61667 5.5 2.375 6.75 1.425C8 0.475 9.41667 0 11 0C12.95 0 14.6042 0.679167 15.9625 2.0375C17.3208 3.39583 18 5.05 18 7C19.15 7.13333 20.1042 7.62917 20.8625 8.4875C21.6208 9.34583 22 10.35 22 11.5C22 12.75 21.5625 13.8125 20.6875 14.6875C19.8125 15.5625 18.75 16 17.5 16H5.5Z"
                        fill="#9B237B" />
                    </svg>
                    <span class="PC_Body2-R text-[#9B237B]"> ซิงค์ข้อมูลแล้ว </span>
                  </div>

                  <div v-else>
                    <div v-if="isOnline">
                      <!-- {{ row.data }} -->
                      <button
                        class="PC_Body2-R text-[#1F1D1F] flex gap-[4px] justify-center w-full border border-[#B7B2B5] p-[6px] rounded-[6px]"
                        @click="syncinfo(row)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path
                            d="M11 12.85L10.1 13.725C9.91667 13.9083 9.6875 14 9.4125 14C9.1375 14 8.9 13.9 8.7 13.7C8.51667 13.5167 8.425 13.2833 8.425 13C8.425 12.7167 8.51667 12.4833 8.7 12.3L11.3 9.7C11.5 9.5 11.7333 9.4 12 9.4C12.2667 9.4 12.5 9.5 12.7 9.7L15.3 12.3C15.4833 12.4833 15.5792 12.7125 15.5875 12.9875C15.5958 13.2625 15.5 13.5 15.3 13.7C15.1167 13.8833 14.8875 13.9792 14.6125 13.9875C14.3375 13.9958 14.1 13.9083 13.9 13.725L13 12.85V18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7917 21 16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2417 19.2 13 18.5 13H17V11C17 9.61667 16.5125 8.4375 15.5375 7.4625C14.5625 6.4875 13.3833 6 12 6C10.6167 6 9.4375 6.4875 8.4625 7.4625C7.4875 8.4375 7 9.61667 7 11H6.5C5.53333 11 4.70833 11.3417 4.025 12.025C3.34167 12.7083 3 13.5333 3 14.5C3 15.4667 3.34167 16.2917 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 18H8C8.28333 18 8.52083 18.0958 8.7125 18.2875C8.90417 18.4792 9 18.7167 9 19C9 19.2833 8.90417 19.5208 8.7125 19.7125C8.52083 19.9042 8.28333 20 8 20H6.5C4.98333 20 3.6875 19.475 2.6125 18.425C1.5375 17.375 1 16.0917 1 14.575C1 13.275 1.39167 12.1167 2.175 11.1C2.95833 10.0833 3.98333 9.43333 5.25 9.15C5.66667 7.61667 6.5 6.375 7.75 5.425C9 4.475 10.4167 4 12 4C13.95 4 15.6042 4.67917 16.9625 6.0375C18.3208 7.39583 19 9.05 19 11C20.15 11.1333 21.1042 11.6292 21.8625 12.4875C22.6208 13.3458 23 14.35 23 15.5C23 16.75 22.5625 17.8125 21.6875 18.6875C20.8125 19.5625 19.75 20 18.5 20H13C12.45 20 11.9792 19.8042 11.5875 19.4125C11.1958 19.0208 11 18.55 11 18V12.85Z"
                            fill="#9B237B" />
                        </svg>
                        ซิงค์ข้อมูล
                      </button>
                      <!-- <span class="PC_Body2-R text-[#1F1D1F]"> ซิงค์ข้อมูล </span> -->
                    </div>
                    <div v-else>
                      <button
                        class="PC_Body2-R text-[#909090] flex gap-[4px] justify-center w-full p-[6px] rounded-[6px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" fill="none">
                          <path
                            d="M5.5 16.775C3.96667 16.775 2.66667 16.2417 1.6 15.175C0.533333 14.1083 0 12.8083 0 11.275C0 9.99167 0.395833 8.85 1.1875 7.85C1.97917 6.85 3 6.20833 4.25 5.925C4.3 5.79167 4.35 5.6625 4.4 5.5375C4.45 5.4125 4.5 5.275 4.55 5.125L1.1 1.675C0.916667 1.49167 0.825 1.25833 0.825 0.975C0.825 0.691667 0.916667 0.458333 1.1 0.275C1.28333 0.0916667 1.51667 0 1.8 0C2.08333 0 2.31667 0.0916667 2.5 0.275L19.5 17.275C19.6833 17.4583 19.7792 17.6875 19.7875 17.9625C19.7958 18.2375 19.7 18.475 19.5 18.675C19.3167 18.8583 19.0875 18.9542 18.8125 18.9625C18.5375 18.9708 18.3 18.8833 18.1 18.7L16.15 16.775H5.5ZM5.5 14.775H14.15L6.1 6.725C6.06667 6.90833 6.04167 7.08333 6.025 7.25C6.00833 7.41667 6 7.59167 6 7.775H5.5C4.53333 7.775 3.70833 8.11667 3.025 8.8C2.34167 9.48333 2 10.3083 2 11.275C2 12.2417 2.34167 13.0667 3.025 13.75C3.70833 14.4333 4.53333 14.775 5.5 14.775ZM20.6 15.525L19.15 14.125C19.4333 13.8917 19.6458 13.6208 19.7875 13.3125C19.9292 13.0042 20 12.6583 20 12.275C20 11.575 19.7583 10.9833 19.275 10.5C18.7917 10.0167 18.2 9.775 17.5 9.775H16V7.775C16 6.39167 15.5125 5.2125 14.5375 4.2375C13.5625 3.2625 12.3833 2.775 11 2.775C10.55 2.775 10.1167 2.82917 9.7 2.9375C9.28333 3.04583 8.88333 3.21667 8.5 3.45L7.05 2C7.63333 1.6 8.25417 1.29583 8.9125 1.0875C9.57083 0.879167 10.2667 0.775 11 0.775C12.95 0.775 14.6042 1.45417 15.9625 2.8125C17.3208 4.17083 18 5.825 18 7.775C19.15 7.90833 20.1042 8.40417 20.8625 9.2625C21.6208 10.1208 22 11.125 22 12.275C22 12.925 21.875 13.5292 21.625 14.0875C21.375 14.6458 21.0333 15.125 20.6 15.525Z"
                            fill="#909090" />
                        </svg>
                        ยังไม่ซิงค์ข้อมูล
                      </button>
                    </div>
                  </div>
                </td>
                <td class="text-center p-[10px] !border-none">
                  <button @click.stop="openMenu($event, row)" class="p-2 rounded-md hover:bg-gray-100 border border-[#B7B2B5]">
                    <!-- ไอคอนจุดสามจุด -->
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24"
                      stroke="#9B237B">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 6.75a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
                    </svg>
                  </button>
                </td>
              </tr>
              <NoInfoYetComponent v-if="offlineList?.length <= 0" :col="'10'" :icon="'NoinfoIcon'" />
            </tbody>
          </table>
        </div>
        <!-- table -->
        <div class="w-full flex justify-end items-center">
          จำนวนแบบประเมินออฟไลน์ : {{ offlineList.length }} / {{ MAX_ITEMS }} ชุด
        </div>
      </div>
    </div>
    <ul v-if="menuOpen == true"
      class="fixed bg-white border border-gray-200 rounded-md shadow-lg w-auto py-2 text-sm text-gray-700 z-[9999]"
      :style="{ top: menuY + 'px', left: menuX + 'px' }" @click.stop>
      <li @click="viewAssessment(menuRow), (menuOpen = false)" class="px-4 py-2 hover:bg-[#FBEFF8] cursor-pointer hover:text-[#9B237B]">
        ดูรายรายละเอียดการประเมิน
      </li>
      <li @click="openOfflineInfo(menuRow), (menuOpen = false)" class="px-4 py-2 hover:bg-[#FBEFF8] cursor-pointer hover:text-[#9B237B]">
        รายละเอียดเพิ่มเติม
      </li>
      <li @click="editAssessment(menuRow), (menuOpen = false)" class="px-4 py-2 hover:bg-[#FBEFF8] cursor-pointer hover:text-[#9B237B]">
        แก้ไข
      </li>
      <li type="button" @click="checkDeleteAssessment(menuRow.id), (menuOpen = false)"
        class="px-4 py-2 hover:bg-[#FBEFF8] cursor-pointer hover:text-[#9B237B]">
        นำออก
      </li>
    </ul>
    <StatusModal ref="statusModalRef" @submit="opennewInfo()" />
    <!-- <StatusModal ref="statusModalRef" /> -->
    <StatusModal ref="statusDeleteModalRef" @submit="deleteOffineInfo()" />
    <OfflineInfo ref="OfflineInfoRef" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, reactive, onBeforeUnmount, nextTick, toRaw } from "vue";
import { useRouter, useRoute } from "vue-router";
import { debounce } from "lodash";
import { inject } from "vue";
import { useOnlineStatus } from "@/composables/useOnlineStatus";
import axios from "axios";
// import {
//   getOfflineAssessments,
//   deleteOfflineAssessment,
//   MAX_ITEMS,
// } from "@/components/Utilities/javascripts/offlineAssessment";
import {
  getOfflineAssessments,
  addOfflineAssessment,
  updateOfflineAssessment,
  deleteOfflineAssessment,
  clearOfflineAssessments,
  MAX_ITEMS,
} from "@/components/Utilities/javascripts/offlineAssessmentStorage";
import { useAuthStore } from "@/pinia/authStore";
// import { updateOfflineAssessment } from "@/components/Utilities/javascripts/offlineAssessment";

import offlineDB from "@/components/Utilities/javascripts/localforage";

const statusModal = inject("statusModal");
// import StatusModal from "@/components/Modals/StatusModal.vue";

const router = useRouter();
const route = useRoute();
const auth = useAuthStore();

const profileData = ref({});

const menuOpen = ref(false);
const menuX = ref(0);
const menuY = ref(0);
const menuRow = ref(null);
const MENU_WIDTH = 160;

const openMenu = (e, row) => {
  const rect = e.currentTarget.getBoundingClientRect();

  menuX.value = rect.right - MENU_WIDTH;   // ลบ window.scrollX ออก
  menuY.value = rect.bottom;               // ลบ window.scrollY ออก
  menuRow.value = row;
  menuOpen.value = !menuOpen.value;
};

const closeMenu = () => {
  menuOpen.value = false;
};

//
const statusModalRef = ref("");
const statusDeleteModalRef = ref("");
const OfflineInfoRef = ref("");

const { isOnline } = useOnlineStatus();

const offlineList = ref([]);

// โหลดรายการ
const loadOfflineAssessments = async () => {
  offlineList.value = await getOfflineAssessments();
  console.log("รายการแบบประเมินออฟไลน์:", offlineList?.value);
};


watch(isOnline, (newVal) => {
  console.log("online changed:", newVal ? "ONLINE" : "OFFLINE");
});

onMounted(async () => {
  await loadOfflineAssessments();
  if (route.query.success === "1") {
    statusModalRef.value.openModal("success", {
      header: "ดำเนินการสำเร็จ !",
      subHeader: "ระบบได้ บันทึกข้อมูล สำเร็จ",
      closeButtonText: "ปิดหน้าต่าง",
      timeout: 5000,
    });
    router.replace({ query: {} });
  }
  if (route.query.success === "2") {
    statusModalRef.value.openModal("success", {
      header: "ดำเนินการสำเร็จ !",
      subHeader: "ระบบได้ เพิ่มข้อมูล และซิงค์ข้อมูล สำเร็จ",
      closeButtonText: "ปิดหน้าต่าง",
      timeout: 5000,
    });
    router.replace({ query: {} });
  }
  profileData.value = await useAuthStore().getProfile();
  console.log("mounted, isOnline:", isOnline.value);
  window.addEventListener("click", closeMenu);

});

onBeforeUnmount(() => {
  window.removeEventListener("click", closeMenu);
});

const addAssessment = (type) => {
  if (type === 1) {
    router.push({ path: `/offline-assessment/offline/offline/null/form1`, query: { from: route.fullPath } });
  } else {
    router.push({ path: `/offline-assessment/offline/offline/null/form2`, query: { from: route.fullPath } });
  }
};

const editAssessment = (data) => {
  if (data.type === 1) {
    router.push({ path: `/offline-assessment/offline/offline/${data.id}/form1`, 
      query: {
      from: route.fullPath,
      edit: 'true'
    } });
  } else {
    router.push({ path: `/offline-assessment/offline/offline/${data.id}/form2`, 
      query: {
      from: route.fullPath,
      edit: 'true'
    } });
  }
};

const viewAssessment = (data) => {
  if (data.type === 1) {
    router.push({ path: `/offline-assessment/offline/offline/${data.id}/form1`, query: { from: route.fullPath } });
  } else {
    router.push({ path: `/offline-assessment/offline/offline/${data.id}/form2`, query: { from: route.fullPath } });
  }
};

const checkDeleteAssessment = async (id) => {
  if (!menuRow.value) return;
  console.log("ฟังก์ชันถูกเรียก");

  try {
    if (menuRow.value?.synced === true) {
      const result = await deleteOfflineAssessment(id);
      console.log('result', result);

      if (result.success) {
        offlineList.value = result.list;
      }

      statusModal.value.openModal("success", {
        header: "ดำเนินการสำเร็จ !",
        subHeader: "ระบบได้ นำข้อมูลออกจากหน้าออฟไลน์ สำเร็จ",
        closeButtonText: "ปิดหน้าต่าง",
        timeout: 1000,
      });
    } else {
      statusDeleteModalRef.value.openModal("warning", {
        header: "คำเตือน !",
        subHeader: "ข้อมูลยังไม่ถูกซิงค์ ท่านต้องการนำแบบประเมิน ออกจากหน้านี้หรือไม่",
        closeButtonText: "ปิดหน้าต่าง",
        submitButtonText: "นำออก",
      });
    }
  } catch (err) {
    console.error("Delete error:", err);
  }
};

const deleteOffineInfo = () => {
  deleteAssessment(menuRow.value.id);
}

const deleteAssessment = async (id) => {
  const ok = await deleteOfflineAssessment(id);
  if (ok) {
    loadOfflineAssessments();
    statusModal.value.openModal("success", {
      header: "ดำเนินการสำเร็จ !",
      subHeader: "ระบบได้ นำข้อมูลออกจากหน้าออฟไลน์ สำเร็จ",
      closeButtonText: "ปิดหน้าต่าง",
      timeout: 5000,
    });
    // if (menuRow.value.synced == true) {
    //   statusModal.value.openModal("success", {
    //     header: "ดำเนินการสำเร็จ !",
    //     subHeader: "ระบบได้ นำข้อมูลออกจากหน้าออฟไลน์ สำเร็จ",
    //     closeButtonText: "ปิดหน้าต่าง",
    //     timeout: 5000,
    //   });
    // } else {
    //   statusModal.value.openModal("warning", {
    //     header: "ดำเนินการสำเร็จ !",
    //     subHeader: "ข้อมูลยังไม่ถูกซิงค์ ท่านต้องการนำแบบประเมิน ออกจากหน้านี้หรือไม่",
    //     closeButtonText: "ปิดหน้าต่าง",
    //     timeout: 5000,
    //   });
    //   // statusDeleteModalRef.value.openModal("warning", {
    //   //     header: "คำเตือน !",
    //   //     subHeader: "ขออภัย ระบบไม่พบข้อมูลของผู้ถูกประเมิน ท่านต้องการเพิ่มข้อมูลผู้ถูกประเมินเข้าสู่ระบบ หรือไม่",
    //   //     closeButtonText: "ปิดหน้าต่าง",
    //   //     timeout: 5000,
    //   // });
    // }
  }
};

const typeToName = (type) => {
  if (type === 1) {
    return "รายงานการปฏิบัติการฉุกเฉิน";
  } else if (type === 2) {
    return "แบบบันทึกเวชระเบียนของทีมปฏิบัติการฉุกเฉิน";
  } else {
    return "ไม่ทราบประเภทแบบประเมิน";
  }
};

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function base64ToFile(base64, filename) {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  const u8arr = new Uint8Array(bstr.length);

  for (let i = 0; i < bstr.length; i++) {
    u8arr[i] = bstr.charCodeAt(i);
  }

  const ext = mime.split("/")[1];
  return new File([u8arr], `${filename}.${ext}`, { type: mime });
}

const syncinfo = async (row) => {
  console.log('rtjrtj',row);
  

  const originalImage = row.data.image; // เก็บของเดิมไว้ก่อน

  let imageFile = originalImage;

  // 👉 ถ้าเป็น base64 → แปลงเป็น File
  if (originalImage) {
    imageFile = base64ToFile(originalImage, "offline-image");
    console.log('imageFile', imageFile);
  }


  const payload = {
    ...row,
    data: {
      ...row.data,
      image: imageFile || "",
    },
    first_name:
      row?.data?.detail?.assessment?.c_first_name ||
      row?.data?.detail?.assessment?.first_name,
    last_name:
      row?.data?.detail?.assessment?.c_last_name ||
      row?.data?.detail?.assessment?.last_name,
    phone: row?.data?.detail?.assessment?.phone || "0987654321",
    datetime: row?.data?.datetime,
  };

  try {


    console.log('row : ', row);
    console.log('payload : ', payload);

    if(row?.data?.synecedId){
      payload.population_id =  row?.data?.population_id
    }

    const cleanPayload = { ...payload };

    if (cleanPayload?.data?.data) {
      delete cleanPayload.data.data;
      console.log('cleanPayload', cleanPayload);
    }

    // const syncedId = null

    const syncedId = row?.data?.synecedId || null;

    const url = syncedId
      ? `/sync-assessment/${syncedId}`
      : "/sync-assessment";

    const response = await axios.post(
      url,
      cleanPayload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      row.synced = true;

      console.log("syncinfo id:", response.data.data.id);
      row.synecedId = response.data.data.id

      await updateOfflineAssessment(row.id, {
        ...row,
        synced: true,
      });

      loadOfflineAssessments();

      statusModalRef.value.openModal("success", {
        header: "ดำเนินการสำเร็จ !",
        subHeader: "ระบบได้ ซิงค์ข้อมูล สำเร็จ",
        closeButtonText: "ปิดหน้าต่าง",
      });
    }
  } catch (error) {
    // rollback image
    row.data.image = originalImage;

    // update localStorage ก่อน
    delete row?.data?.data
    console.log("add-formOffline", row?.data);

    // localStorage.setItem("add-formOffline", JSON.stringify(row?.data));
    // localStorage.setItem("add-assessment", JSON.stringify(row?.data));



    // 🔥 รอให้ offline update เสร็จก่อน
    await await updateOfflineAssessment(row.id, {
      ...row,
      synced: false,
      data: row.data,
    });

    // แล้วค่อยเปิด modal
    statusModalRef.value.openModal("warning", {
      header: "คำเตือน !",
      subHeader: error.response?.data?.message || "ซิงค์ไม่สำเร็จ",
      closeButtonText: "ปิดหน้าต่าง",
      submitButtonText: "เพิ่มข้อมูลใหม่",
    });


    const safeData = deepClean(toRaw(row?.data));
    if (!safeData.id) safeData.id = row.id;
    console.log('safeData', safeData);
    // console.log(row.data);
    // console.log(typeof row.data.image);
    // console.log(row.data.created_at);


    await offlineDB.setItem("add-formOffline", safeData);
    await offlineDB.setItem("add-assessment", safeData);

    // const data = await offlineDB.getItem("add-assessment");
    // console.log("FROM IDB", data);
  }
};

function deepClean(obj) {
  return JSON.parse(JSON.stringify(obj, (key, value) => {
    if (value instanceof Date) return value.toISOString();
    if (typeof value === "function") return undefined;
    if (value === undefined) return null;
    return value;
  }));
}

const opennewInfo = () => {
  router.push("/population/total-population/offline/add-population-newinfo");
};

const openOfflineInfo = (data) => {
  console.log(data.data.create_by);

  const dataRaw = {
    ...data,
    profileData: data.data.create_by,
  };
  OfflineInfoRef.value.openModal(dataRaw);
};

function formatThaiDate(dateString) {
  const date = new Date(dateString);

  // แปลงเป็นเวลาไทย
  const thaiDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Bangkok" }));

  const day = String(thaiDate.getDate()).padStart(2, "0");
  const month = String(thaiDate.getMonth() + 1).padStart(2, "0");
  const year = thaiDate.getFullYear() + 543;

  const hours = String(thaiDate.getHours()).padStart(2, "0");
  const minutes = String(thaiDate.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year}, ${hours}:${minutes}`;
}

function formatDate(dateString) {
  const date = new Date(dateString);

  // แปลงเป็นเวลาไทย
  const thaiDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Bangkok" }));

  const day = String(thaiDate.getDate()).padStart(2, "0");
  const month = String(thaiDate.getMonth() + 1).padStart(2, "0");
  const year = thaiDate.getFullYear() + 543;

  return `${day}/${month}/${year}`;
}
</script>

<style lang="scss" scoped></style>
